import Link from 'components/shared/Link/Link';
import { CalloutColumns, CopyJustification, KeyLinePosition } from 'types/constants';
import { cn } from 'utils/styles';
import { CalloutGridCardProps, CalloutGridVariants } from './types';
import { getBorderClasses } from './utils';

interface CalloutGridCardComponentProps {
  card: CalloutGridCardProps;
  index: number;
  columns: CalloutColumns;
  keyline?: KeyLinePosition;
  copyJustification?: CopyJustification;
  children?: React.ReactNode;
  variant: CalloutGridVariants;
}

const CalloutGridCard = ({ card, index, columns, keyline, children, variant }: CalloutGridCardComponentProps) => {
  const isImageVariant = variant === CalloutGridVariants.Image;

  const isLinkedCard = card.link != null;
  const showBetweenKeylines = keyline === KeyLinePosition.Between && !isImageVariant; // Keylines are not supported for image variants

  const cardClasses = cn(
    'w-full',
    showBetweenKeylines && 'sm:pr-6 sm:border-r-2 sm:border-(--keyline-color) sm:border-opacity-20',
    // Remove right border for last item in each row based on responsive grid
    showBetweenKeylines && getBorderClasses(columns),
    showBetweenKeylines && 'sm:last:border-r-0',
    isLinkedCard && 'rounded-none hover:text-current transition-all hover:opacity-80 focus:opacity-80',
  );

  const Wrapper = isLinkedCard ? Link : 'div';
  const wrapperProps = isLinkedCard
    ? { href: card?.link?.url, internalPage: card?.link?.internalPage, isSubnav: true }
    : {};

  return (
    <Wrapper key={index} className={cardClasses} {...wrapperProps}>
      {children}
    </Wrapper>
  );
};

export default CalloutGridCard;
